<template>
    <!-- 穿梭框组件 -->
    <el-transfer 
    v-model="value" 
    :data="transferList"
    :filterable="filterable"
    :filter-method="filterFn"
    :filter-placeholder="placeholder"
    :left-default-checked="leftChecked"
    :right-default-checked="rightChecked"
    :render-content="renderFn"
    :titles="titles"
    :button-texts="btnTexts"
    :format="format"
    :props="props"
    :target-order="targetOrder"
    @change="change"
    >   
        <!-- 默认内容插槽 -->
        <span slot-scope="{ option }">
            <slot :option="option">
                {{option.label}}
            </slot>
        </span>
        <!-- 左边列表底部插槽 -->
        <template #left-footer>
            <slot name="lfooter"></slot>
        </template>
        <!-- 右边列表底部插槽 -->
        <template #right-footer>
            <slot name="rfooter"></slot>
        </template>
    </el-transfer>
</template>
<script>
export default {
    name:"VelTransfer",
    props:{
        initValue:Array,
        placeholder:String,
        leftChecked:Array,
        rightChecked:Array,
        titles:Array,
        btnTexts:Array,
        format:Object,
        props:Object,
        targetOrder:String,
        renderFn:Function,
        filterFn:Function,
        isFilter:Boolean,
        transferList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            value:[],
            filterable:false,
        };
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value =  newval
            },
            deep:true,
            immediate:true,
        }
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isFilter ? this.filterable = true : this.filterable
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = []
        },
        change(val,direction,keyarr){
            this.$emit('change',val,direction,keyarr)
        }
    }
}
</script>